import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class RouseService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',

    })
  };

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private toastr: ToastrService) {

  }

  async getCountries(): Promise<any[]> {
    let countries = null;

    await this.http.get<any[]>(this.baseUrl + 'api/data/GetCountries', this.httpOptions)
      .toPromise()
      .then(data => {
        countries = data;
      });
    return countries;
  }

  async getAllTechnicalFields(): Promise<any[]> {
    let technicalfields = null;

    await this.http.get<any[]>(this.baseUrl + 'api/data/GetAllTechnicalFields', this.httpOptions)
      .toPromise()
      .then(data => {
        technicalfields = data;
      });
    return technicalfields;
  }

  async getProtectionTypes(countryId: number): Promise<any[]> {
    let protectionTypes: any[] = [];

    await this.http.get<any[]>(this.baseUrl + `api/data/GetProtectionTypes/${countryId}`, this.httpOptions)
      .toPromise()
      .then(data => { protectionTypes = data; });
    return protectionTypes;
  }

  async getProtectionType(countryId: number, protectionTypeId: number): Promise<any> {
    let protectionType = null;
    await this.http.get<any[]>(this.baseUrl + `api/data/GetProtectionType/${countryId}/${protectionTypeId}`, this.httpOptions)
      .toPromise()
      .then(data => { protectionType = data; });
    return protectionType;
  }


  async getFilingRoutes(countryId: number, protectionTypeId: number): Promise<any[]> {
    let filingRoutes: any[] = null;
    await this.http.get<any[]>(this.baseUrl + `api/data/GetFilingRoutes/${countryId}/${protectionTypeId}`)
      .toPromise()
      .then(data => { filingRoutes = data; });
    return filingRoutes;
  }

  async getFilingRoute(countryId: number, protectionTypeId: number, filingRouteId: number): Promise<any> {
    let filingRoute = null;
    await this.http.get<any[]>(this.baseUrl + `api/data/GetFilingRoute/${countryId}/${protectionTypeId}/${filingRouteId}`, this.httpOptions)
      .toPromise()
      .then(data => { filingRoute = data; });
    return filingRoute;
  }


  async getTechnicalFields(countryId: number, protectionTypeId: number, filingRouteId: number): Promise<any[]> {
    let technicalFields: any[] = [];
    await this.http.get<any[]>(this.baseUrl + `api/data/GetTechnicalFields/${countryId}/${protectionTypeId}/${filingRouteId}`, this.httpOptions)
      .toPromise()
      .then(data => { technicalFields = data; });
    return technicalFields;
  }


  async getStepDuration(countryId: number, protectionTypeId: number, filingRouteId: number, technicalFieldId: number): Promise<any[]> {
    let steps: any[] = [];
    await this.http.get<any>(this.baseUrl + 'api/data/GetStepDuration/' + countryId.toString() + '/' + protectionTypeId.toString() + '/' + filingRouteId.toString() + '/' + technicalFieldId.toString())
      .toPromise()
      .then(data => {
        steps = JSON.parse(data.data);
      })
    return steps;
  }

  async getSavedReportData(username: string): Promise<any[]> {
    let calculatorData: any[] = [];
    await this.http.get<any[]>(this.baseUrl + `api/data/GetSavedReportData/${username}`, this.httpOptions)
      .toPromise()
      .then(data => { calculatorData = data; });
    return calculatorData;
  }

  async validateSavedReportData(fileName: string, id: number, username: string): Promise<boolean> {
    let isValid = false;
    await this.http.get<boolean>(this.baseUrl + `api/data/ValidateSavedReportData/${fileName}/${id}/${username}`, this.httpOptions)
      .toPromise()
      .then(data => {
        isValid = data;
      });
    return isValid;
  }

  async GetSavedReportDataById(username: string, id: number): Promise<any> {
    let calculatorData: any;
    await this.http.get<any>(this.baseUrl + `api/data/GetSavedReportDataById/${username}/${id}`, this.httpOptions)
      .toPromise()
      .then(data => { calculatorData = data; });
    return calculatorData;
  }

  parseStepDurations(countryData: any, typeOfApplication: string, filingMethod: string): any {
    let k1 = this.camelCase(typeOfApplication);
    let k2 = this.camelCase(filingMethod);
    return countryData[k1][k2].steps;
  }

  async postSavedReportData(calculatorModel: any): Promise<string> {
    let retValue: any = ""
    await this.http.post<string>(this.baseUrl + 'api/data/PostSavedReportData', calculatorModel, this.httpOptions)
      .toPromise()
      .then((data) => {
        retValue = data;
        this.toastr.success("Successfully saved.");
      }).catch((error) => {
        this.toastr.error(error);
      });
    return retValue;
  }

  async generatePDF(reportData: any): Promise<string> {
    let retValue: any = ""
    await this.http.post<string>(this.baseUrl + 'api/data/GeneratePDF', reportData, this.httpOptions)
      .toPromise()
      .then((data) => {
        retValue = data;
      }).catch((error) => {
        this.toastr.error(error);
      });
    return retValue;
  }

  async deleteSavedReportData(calculatorModel: any): Promise<string> {
    let retValue: any = ""
    await this.http.post<string>(this.baseUrl + 'api/data/DeleteSavedReportData', calculatorModel, this.httpOptions)
      .toPromise()
      .then((data) => {
        retValue = data;
        this.toastr.success("Successfully deleted.");
      }).catch((error) => {
        this.toastr.error(error);
      });
    return retValue;
  }

  async sendEmail(attachments: { OriginalFileName: string, Base64Content: string }[], sendTo: string, firstName: string): Promise<string> {
  let retValue: any = "";

  const htmlBody =
    "<image src=https://www.patempo.com/logo-patempo.png  style=\"height: 35px;\"><br>" +
    "</br>" +
    "Dear " + firstName + ", </br>" +
    "</br>" +
    "<p><b>Congratulations!</b> Thank you for using the Patempo Calculator.</p>" +
    "<p>Your estimate has been completed by the Patempo Calculator. Attached herewith is your copy of the estimate. We hope you'll find your estimate useful and will visit again to help you with your pendency estimate needs.</p>" + 
    "<p>Don't hesitate to contact us should you have any questions or concerns.</p></br>" +     
    "<p> </p>" +
    "<p> Regards,</p>" +
    "<p>Patempo Team</p></br>";

  const request = {
    Subject: "Patent Pendency Report",
    HtmlBody: htmlBody,
    To: [sendTo],
    Cc: [],
    Bcc: [],
    Attachments: attachments
  };

  await this.http.post<string>(this.baseUrl + 'api/data/SendEmail', request, this.httpOptions)
    .toPromise()
    .then((data) => {
      retValue = data;
      this.toastr.success(data);
    }).catch((error) => {
      this.toastr.error(error);
    });

  return retValue;
}


  camelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }
}

